import { useEffect } from 'react';

/**
 * v2 페이지 공통 — body height:100% 제약 해제
 * 기존 CSS가 body를 뷰포트에 고정하기 때문에 v2 페이지에서는
 * 동적으로 해제해서 자연 스크롤을 활성화합니다.
 */
export default function useBodyScroll() {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    html.style.height = 'auto';
    html.style.overflowY = 'auto';
    body.style.height = 'auto';
    body.style.overflowY = 'auto';
    return () => {
      html.style.height = '';
      html.style.overflowY = '';
      body.style.height = '';
      body.style.overflowY = '';
    };
  }, []);
}
